const sendSegmentAnalytics = (action, step, user, fields) => {
  const {password, password_confirmation, avatar, ...formData} = fields

  try {
    analytics.track(`${action} Registration Step`, {
      step: step,
      step_name: getStepName(step),
      user: user,
      form_data: action === 'Submitted' ? formData : undefined
    })
  } catch (e) {
    console.log(e)
  }
}

const getStepName = (step) => {
  var stepName

  if (step === 1) stepName = 'Basic Info'
  if (step === 2) stepName = 'Verify Email CTA'
  if (step === 3) stepName = 'Approval Pending'
  if (step === 4) stepName = 'Additional Personal Info'
  if (step === 5) stepName = 'Registration Complete'

  return stepName
}

export {
  sendSegmentAnalytics
}
